/** 门户设备介绍：展示 HTML 构建与兜底修复 */

import { ensureTableTabsDisplayHtml, upgradeLegacyTablesInHtml } from '@/components/shared/utils/tableTabs'
import { parseHtmlFragment, relocateInlineStylesInHtml } from '@/components/shared/utils/promoteInlineStyles'

export const EQUIPMENT_INTRO_TYPE = 'equipment-intro'

function escapeHtml(text) {
  return String(text ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}

function normalizeMediaPosition(value) {
  return value === 'left' ? 'left' : 'right'
}

function normalizeSrc(value) {
  return typeof value === 'string' ? value.trim() : ''
}

function normalizeContent(value) {
  return typeof value === 'string' ? value : ''
}

function buildEquipmentIntroConfig(attrs = {}) {
  return {
    src: normalizeSrc(attrs.src),
    mediaPosition: normalizeMediaPosition(attrs.mediaPosition),
    content: normalizeContent(attrs.content),
  }
}

function contentToHtml(content) {
  const value = String(content || '')
  if (!value) return ''
  if (/<[a-z][\s\S]*>/i.test(value)) {
    return ensureTableTabsDisplayHtml(upgradeLegacyTablesInHtml(value))
  }
  return value
    .split(/\n/)
    .map((line) => `<p>${escapeHtml(line) || '<br>'}</p>`)
    .join('')
}

export function buildEquipmentIntroHtml(attrs = {}, { resolveSrc } = {}) {
  const config = buildEquipmentIntroConfig(attrs)
  const resolve = typeof resolveSrc === 'function' ? resolveSrc : (src) => src || ''
  const src = resolve(config.src)
  const dataConfig = escapeHtml(JSON.stringify(config))
  const pos = config.mediaPosition
  const copyHtml = contentToHtml(config.content)
  const mediaInner = src
    ? `<img src="${escapeHtml(src)}" alt="" class="equipment-intro__img">`
    : ''
  return (
    `<section data-type="${EQUIPMENT_INTRO_TYPE}" data-config="${dataConfig}" data-media-position="${pos}" class="equipment-intro is-media-${pos}">` +
    `<div class="equipment-intro__inner">` +
    `<div class="equipment-intro__copy">${copyHtml}</div>` +
    `<div class="equipment-intro__media">${mediaInner}</div>` +
    `</div></section>`
  )
}

function parseConfigAttr(element) {
  try {
    const raw = element.getAttribute('data-config')
    if (!raw) return null
    const parsed = JSON.parse(raw)
    if (!parsed || typeof parsed !== 'object') return null
    return buildEquipmentIntroConfig(parsed)
  } catch {
    return null
  }
}

function parseDomStructure(element) {
  const fromData = element.getAttribute('data-media-position')
  const cls = String(element.className || '')
  const match = cls.match(/is-media-(left|right)/)
  const img = element.querySelector('.equipment-intro__media img, img')
  const copy = element.querySelector('.equipment-intro__copy')
  return {
    src: img?.getAttribute('src') || '',
    mediaPosition: normalizeMediaPosition(fromData || match?.[1]),
    content: copy?.innerHTML || '',
  }
}

export function repairEquipmentIntroHtml(html) {
  if (!html || !html.includes('equipment-intro')) return html
  try {
    const parsed = parseHtmlFragment(html, '__equipment_root')
    if (!parsed?.root) return html
    const { doc, root: fragment } = parsed
    fragment.querySelectorAll(`[data-type="${EQUIPMENT_INTRO_TYPE}"]`).forEach((root) => {
      const config = parseConfigAttr(root) || parseDomStructure(root)
      const normalized = buildEquipmentIntroConfig(config)
      const pos = normalized.mediaPosition
      root.classList.add('equipment-intro')
      root.classList.remove('is-media-left', 'is-media-right')
      root.classList.add(`is-media-${pos}`)
      root.setAttribute('data-media-position', pos)
      root.setAttribute('data-config', JSON.stringify(normalized))

      let inner = root.querySelector(':scope > .equipment-intro__inner')
      if (!inner) {
        inner = doc.createElement('div')
        inner.className = 'equipment-intro__inner'
        while (root.firstChild) inner.appendChild(root.firstChild)
        root.appendChild(inner)
      }

      let copy = inner.querySelector(':scope > .equipment-intro__copy')
      if (!copy) {
        copy = doc.createElement('div')
        copy.className = 'equipment-intro__copy'
        inner.insertBefore(copy, inner.firstChild)
      }
      if (normalized.content && !String(copy.innerHTML || '').trim()) {
        copy.innerHTML = relocateInlineStylesInHtml(contentToHtml(normalized.content))
      }

      let media = inner.querySelector(':scope > .equipment-intro__media')
      if (!media) {
        media = doc.createElement('div')
        media.className = 'equipment-intro__media'
        inner.appendChild(media)
      }
      const src = normalizeSrc(normalized.src)
      if (src) {
        let img = media.querySelector('img')
        if (!img) {
          img = doc.createElement('img')
          img.alt = ''
          media.appendChild(img)
        }
        img.src = src
        img.classList.add('equipment-intro__img')
      }
    })
    return fragment.innerHTML
  } catch {
    return html
  }
}
